var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"mt-7 mx-4"},[_c('v-col',[_c('v-pagination',{attrs:{"color":"primary","length":_vm.totalPages,"total-visible":7},on:{"input":_vm.cambiarPagina},model:{value:(_vm.pagina),callback:function ($$v) {_vm.pagina=$$v},expression:"pagina"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }